export default __webpack_public_path__ + "static/media/mulheres-silhueta.63ce86bb.png";